// extracted by mini-css-extract-plugin
module.exports = {"newlight":"StoryNewLight_newlight__WkRRq","mobile_newlight":"StoryNewLight_mobile_newlight__9zKM9"};